import styled from "styled-components/macro";

// import theme helpers
import { getBreakpoint, getColor, getFontWeight } from "../../../../util/theme";

const AboutContainer = styled.section`
  background-color: #f4f5f6;
  padding: 70px 20px !important;

  @media (min-width: ${getBreakpoint("lg")}) {
    padding: 85px 0 70px 0;
  }

  @media (min-width: ${getBreakpoint("md")}) {
    padding: 70px 120px !important;
  }

  @media (min-width: ${getBreakpoint("xl")}) {
    padding: 70px 160px !important;
  }

  p {
    color: ${getColor("black")};
    font-size: 1.9rem;
    font-weight: ${getFontWeight("light")};
    line-height: 1.5;
    margin-top: 0;
    padding: 6px;
  }

  .about-section-image {
    max-width: 100%;
    display: block;
    margin: 0 auto 32px;

    @media (min-width: ${getBreakpoint("lg")}) {
      max-width: 500px;
    }
  }

  .about-heading {
    color: ${getColor("primaryBlue")};
    font-weight: ${getFontWeight("bold")};
    margin: 0 0 30px;
    padding: 0;
    text-align: center;

    @media (min-width: ${getBreakpoint("lg")}) {
      font-size: 3.75rem;
    }
  }

  .about-content {
    display: grid;
    gap: 32px;
    align-items: start;

    @media (min-width: ${getBreakpoint("md")}) {
      gap: 56px;
      grid-template-columns: 380px minmax(0, 1fr);
    }
  }

  .about-profile {
    text-align: center;

    @media (min-width: ${getBreakpoint("md")}) {
      width: 380px;
    }
  }

  .about-headshot {
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
    border: 2px solid ${getColor("grey")};
    border-radius: 50%;
    height: 220px;
    margin: 0 auto 18px;
    width: 220px;

    @media (min-width: ${getBreakpoint("md")}) {
      height: 320px;
      width: 320px;
    }
  }

  .about-profile h3 {
    color: ${getColor("black")};
    font-size: 2.2rem;
    font-weight: ${getFontWeight("bold")};
    margin: 0;
  }

  .about-profile .about-title {
    font-size: 1.6rem;
    font-weight: ${getFontWeight("regular")};
    line-height: 1.3;
    margin: 6px 0 0;
    padding: 0;
  }
`;

export default AboutContainer;
